// ── Единый детектор «чанк не загрузился» ────────────────────────────────────
// После деплоя старая вкладка просит content-hashed чанк, которого на текущем
// деплое уже нет. Cloudflare Pages не умеет отдавать 404 из _redirects (см.
// erp/public/_redirects), поэтому вместо скрипта прилетает index.html со
// статусом 200 — и браузер отвергает модуль по strict-MIME.
//
// Формулировка ошибки у каждого движка СВОЯ, и раньше recovery-логика знала
// только вариант Chrome. У пользователей на WebKit/Firefox авто-восстановление
// молча не срабатывало: вместо перезагрузки они видели красный стек и кнопку
// «Попробовать снова», которая ничего не чинит (инцидент 2026-08-10, Ушаков —
// «Сбой загрузки модуля» при сохранении карточки партнёра).
//
// Держим список формулировок в ОДНОМ месте: и lazyWithRetry, и
// PageErrorBoundary обязаны судить одинаково, иначе один включает recovery,
// а второй показывает тупиковый экран.
const CHUNK_ERROR_SIGNATURES = [
    // Chromium
    'failed to fetch dynamically imported module',
    // Firefox
    'error loading dynamically imported module',
    'disallowed mime type',
    // WebKit / Safari
    'is not a valid javascript mime type',
    'importing a module script failed',
    'module source uri is not allowed',
    // Bundler-level (webpack legacy, Vite preload helper)
    'chunkloaderror',
    'loading chunk',
    'loading css chunk',
    'unable to preload css',
]

/**
 * Возвращает true, если ошибка — это «чанк не доехал / протух», а не ошибка
 * внутри самого компонента. Принимает Error, строку или что угодно.
 */
export function isChunkLoadError(err) {
    if (!err) return false
    if (err.name === 'ChunkLoadError') return true

    const haystack = `${err.name || ''} ${err.message || ''} ${String(err)}`.toLowerCase()
    return CHUNK_ERROR_SIGNATURES.some((sig) => haystack.includes(sig))
}

export default isChunkLoadError
